module.exports = __webpack_public_path__ + "img/string-diagram-vertical.6f13d574.png";